// src/context/SystemConfigContext.js
import { createContext, useContext, useState } from "react";

const SystemConfigContext = createContext();

export const SystemConfigProvider = ({ children }) => {
  const [systemSettings, setSystemSettings] = useState({});

  return (
    <SystemConfigContext.Provider value={{ systemSettings, setSystemSettings }}>
      {children}
    </SystemConfigContext.Provider>
  );
};

export const useSystemConfig = () => useContext(SystemConfigContext);
